/* ============
 * Getters for the auth module
 * ============
 *
 * The getters that are available on the
 * auth module.
 */

export default {}


// WEBPACK FOOTER //
// ./src/store/modules/sinisters/getters.js